export const enum IsRootProduct {
  YES = "YES",
  NO = "NO"
}

export enum CalculationFilterStatus {
  CALCULATED = "Calculated",
  NOT_CALCULATED = "Not Calculated",
  NONE = ""
}
